import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ParallaxLayer from "./parallax_layer.js";
import { ReactComponent as IconCountry } from '../../media/icons/country.svg';
import { ReactComponent as IconLocation } from '../../media/icons/location.svg';


export default class Hero extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            searchbox_input: "",
            searchbox_input_active: false,
            searchbox_dropdown: [],
            scrollY: 0,
            scrollYFactor: 0.6,
            parallax_layers: [
                {
                    number: 1,
                    url: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/hero/hero_6.webp",
                    factor: "0.6"
                },
                {
                    number: 2,
                    url: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/hero/hero_5.webp",
                    factor: "0.5"
                },
                {
                    number: 3,
                    url: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/hero/hero_4.webp",
                    factor: "0.4"
                },
                {
                    number: 4,
                    url: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/hero/hero_3.webp",
                    factor: "0.3"
                },
                {
                    number: 5,
                    url: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/hero/hero_2.webp",
                    factor: "0.2"
                },
                {
                    number: 6,
                    url: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/hero/hero_1.webp",
                    factor: "0.1"
                }
            ]
        };

        this.inputField = React.createRef();

        this.clickInput = this.clickInput.bind(this);
        this.focusInput = this.focusInput.bind(this);
        this.blurInput = this.blurInput.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.filterLocations = this.filterLocations.bind(this);
    }


    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }


    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }


    handleScroll = () => {
        this.setState({ scrollY: window.scrollY });
    }


    clickInput() {
        this.inputField.current.focus();
    }


    focusInput() {
        this.setState({
            searchbox_input_active: true
        });
    }


    blurInput() {
        this.setState({
            searchbox_input_active: false
        });
    }


    handleInputChange(event) {
        var value = event.target.value;
        this.setState({
            searchbox_input: value
        });
        if (value.length >= 2) {
            this.filterLocations(value);
        } else {
            this.setState({
                searchbox_dropdown: []
            });
        };
    }


    filterLocations(searchTerm) {
        try {
            var locations = this.props.locations;
            const lowerSearchTerm = searchTerm.toLowerCase();
            var dropdown = [];
            var length = 20;
            var counter = 0;
            for (const country in locations) {
                if (counter <= length) {
                    if (country.toLowerCase().includes(lowerSearchTerm)) {
                        dropdown.push({
                            country: country
                        });
                        counter++;
                    }
                }
            }
            for (const country in locations) {
                for (const city of locations[country]) {
                    if (counter <= length) {
                        if (city.toLowerCase().includes(lowerSearchTerm)) {
                            dropdown.push({
                                country: country,
                                city: city
                            });
                            counter++;
                        }
                    }
                }
            }
            this.setState({
                searchbox_dropdown: dropdown
            });
        } catch (error) {
            // Track error
            var name = "Server error";
            var message = "Could not filter location data. Please check the URL and try again.";
            this.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Home_filterLocations");
        }
    }


    getlocationcode(country) {
        try {
            return this.props.locationcodes[country];
        } catch (error) {
            return false;
        }
    }


    render() {

        return (
            <div className="content-container hero-container">
                {this.state.parallax_layers.map((layer) => (
                    <ParallaxLayer key={layer.number} number={layer.number} url={layer.url} factor={layer.factor} scrollY={this.state.scrollY} />
                ))}
                <div className="hero__background hero__background--overlay"  style={{ transform: `translateY(${this.state.scrollY * this.state.scrollYFactor}px)` }}></div>
                <div className="content-wrapper--wide hero-wrapper">
                    <div className="hero__title-container">
                        <div className="hero__title text-title text-center text-color-light">
                            <h1 className="hero__title__static-content text-color-light">
                                {"Find the best travel guides for "}
                            </h1>
                            <div className="hero__title__dynamic-word-container">
                                <div className="hero__title__dynamic-word"></div>
                            </div>
                        </div>
                    </div>
                    <div className="hero__searchbox-container">
                        <div className={"hero__searchbox-wrapper" + (this.state.searchbox_dropdown.length >= 1 ? " hero__searchbox-wrapper--expanded" : "")}>
                            <div className="hero__searchbox">
                                <div className="hero__searchbox__input-container">
                                    {(this.props.locations) &&
                                        <input autoComplete="off" ref={this.inputField} onFocus={this.focusInput} onBlur={this.blurInput} onChange={this.handleInputChange} type="text" id={"searchbox_input"} name={"searchbox_input"} value={this.state.searchbox_input && this.state.searchbox_input !== "" ? this.state.searchbox_input : ""} placeholder="Where to go?" className="hero__searchbox__input" />
                                    }
                                    {!(this.props.locations) &&
                                        <div className="hero__searchbox__input__loader">
                                            Loading ...
                                        </div>
                                    }
                                </div>
                                {/* <Link to={"/trips/" + this.state.searchbox_input} className="hero__searchbox__button button button-primary">
                                    Find trips
                                </Link> */}
                            </div>


                            {this.state.searchbox_dropdown.length >= 1 &&
                                <div className={"hero__searchbox__results-container" + (this.state.searchbox_dropdown.length >= 1 ? " hero__searchbox__results-container--expanded" : "")}>
                                    {this.state.searchbox_dropdown.map((location, i) => (
                                        <Link to={"/trips?" + (location.country ? "country=" + location.country + "&" : "") + (location.city ? "city=" + location.city : "")} key={i} className="hero__searchbox__results__element">
                                            <div className="hero__searchbox__results__element__icon">
                                                {/* {location.city
                                                    ? (<IconLocation className={"hero__searchbox__results__element__icon-inner"} />)
                                                    : (<IconCountry className={"hero__searchbox__results__element__icon-inner"} />)
                                                } */}
                                                {<img className="hero__searchbox__results__element__icon-flag-inner" src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/country-flags/" + this.getlocationcode(location.country) + ".png"} />}
                                            </div>
                                            <div className="hero__searchbox__results__element__label">
                                                {location.city ? location.city + ", " + location.country : location.country}
                                            </div>
                                        </Link>
                                    ))}

                                </div>
                            }

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
